import React from 'react';
import { fmt3 } from '../leaseGeneralInvoiceReceipt/allocationHelpers';

/** Bottom panel: the basket. lines: { key, leaseNo, propertyName, unitNo, tenantName, paymentTypeDesc, creditAccountCode, amount } */
const LinesGrid = ({ lines, allocated, onRemove, disabled }) => (
    <div className="border-box2 p-3">
        <div className="table-responsive">
            <table className="table table-sm align-middle mb-0">
                <thead>
                    <tr style={{ background: '#6E5199', color: '#fff' }}>
                        <th>Lease No</th>
                        <th>Property</th>
                        <th>Unit</th>
                        <th>Tenant</th>
                        <th>Payment Type</th>
                        <th>Credit Account</th>
                        <th className="text-end">Amount</th>
                        <th style={{ width: 90 }} />
                    </tr>
                </thead>
                <tbody>
                    {lines.length === 0 ? (
                        <tr><td colSpan={8} className="text-center text-muted p-3">No lines added yet.</td></tr>
                    ) : lines.map((l) => (
                        <tr key={l.key}>
                            <td>{l.leaseNo}</td>
                            <td>{l.propertyName}</td>
                            <td>{l.unitNo}</td>
                            <td>{l.tenantName}</td>
                            <td>{l.paymentTypeDesc}</td>
                            <td>{l.creditAccountCode}</td>
                            <td className="text-end">{fmt3(l.amount)}</td>
                            <td className="text-end">
                                <button type="button" className="btn btn-sm btn-outline-danger" disabled={disabled} onClick={() => onRemove(l.key)}>
                                    Remove
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr className="fw-bold">
                        <td colSpan={6}>Allocated total ({lines.length} {lines.length === 1 ? 'line' : 'lines'})</td>
                        <td className="text-end">{fmt3(allocated)}</td>
                        <td />
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
);

export default LinesGrid;
